/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { LayoutUtils } from "abreact/layout/LayoutUtils";

/**
 * Properties of the AbVBox component.
 */

/**
 * The **AbVBox** component is a box that lays out its children vertically.
 */
export const AbVBox = props => {
  return LayoutUtils.renderBox("ab-vbox", props);
};
//# sourceMappingURL=AbVBox.js.map
